module.exports = __webpack_public_path__ + "img/offline-activity-set-default.5396a0ea.png";